import React, { useState, useEffect } from "react";
import styles from "./carousell.module.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { motion } from "framer-motion";

const Carousell = ({ children, title, subtitle }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const items = React.Children.toArray(children);
  const totalItems = items.length;
  const [itemsPerView, setItemsPerView] = useState(4);

  useEffect(() => {
    const updateItems = () => {
      if (window.innerWidth < 640) setItemsPerView(1.2); // Mostra um pedaço do próximo card
      else if (window.innerWidth < 1024) setItemsPerView(2.5);
      else setItemsPerView(4);
    };
    updateItems();
    window.addEventListener("resize", updateItems);
    return () => window.removeEventListener("resize", updateItems);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1 > totalItems - Math.floor(itemsPerView) ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 < 0 ? totalItems - Math.floor(itemsPerView) : prev - 1));
  };

  if (totalItems === 0) return null;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.titleGroup}>
            {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
            {title && <h2 className={styles.title}>{title}</h2>}
          </div>
          <div className={styles.controls}>
            <button className={styles.navBtn} onClick={prevSlide}><FaChevronLeft /></button>
            <button className={styles.navBtn} onClick={nextSlide}><FaChevronRight /></button>
          </div>
        </div>

        <div className={styles.carouselWrapper}>
          <motion.div 
            className={styles.track}
            animate={{ x: `-${currentIndex * (100 / itemsPerView)}%` }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
          >
            {items.map((child, index) => (
              <div 
                key={index} 
                className={styles.cardItem}
                style={{ flex: `0 0 ${100 / itemsPerView}%` }}
              >
                {child}
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Carousell;